import ThemeProvider from './theme-provider';

export { ThemeProvider };
